import { useQueries, useQuery } from "@tanstack/react-query";
import { api } from "../../api/client";
import type { ListResponse, Location, Venue } from "../../api/types";

export function useVenues() {
  return useQuery({
    queryKey: ["venues"],
    queryFn: () => api<ListResponse<Venue>>("/api/v1/venues"),
  });
}

export function useAllLocations(venues: Venue[]) {
  const queries = useQueries({
    queries: venues.map((venue) => ({
      queryKey: ["venues", venue.id, "locations"],
      queryFn: () => api<ListResponse<Location>>(`/api/v1/venues/${venue.id}/locations`),
      staleTime: 30_000,
    })),
  });
  return {
    locations: queries.flatMap((query) => query.data?.items ?? []),
    loading: queries.some((query) => query.isLoading),
    error: queries.find((query) => query.error)?.error,
  };
}
